import type { HTMLAttributes, ReactNode } from 'react';

export type KbdSize = 'sm' | 'md' | 'lg';

export interface KbdProps extends Omit<HTMLAttributes<HTMLElement>, 'className'> {
  size?: KbdSize;
  className?: string;
  children: ReactNode;
}

/** Renders a `<kbd>` element styled as a key cap. Provide `size` to
 *  match surrounding type scale (sm for inline hints inside menu items,
 *  md for standalone shortcut hints, lg for cheatsheets). */
export function Kbd(props: KbdProps): ReactNode {
  const { size, className, children, ...rest } = props;
  const classes = ['vq-kbd', className].filter(Boolean).join(' ');
  return (
    <kbd {...rest} className={classes} data-component="Kbd" data-size={size}>
      {children}
    </kbd>
  );
}
